// extracted by mini-css-extract-plugin
export default {"link":"JournalEntryCard_link__tE+tH","title-section":"JournalEntryCard_title-section__PDgfk","title":"JournalEntryCard_title__xxc0k"};